import { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import './App.css';

function Leader(props) {
  const [leaders, setLeaders] = useState([])
  const leadersRef = useRef(leaders);
  leadersRef.current = leaders;
  const setLeadersRef = useRef(setLeaders);
  setLeadersRef.current = setLeaders;

  const loadingLeaderboard = () => {
    var init = { method: 'POST',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify({
        "mission": props.mission
    }) };
    fetch("https://escape.funatmdf.click/leaderboard", init)
      .then(res => res.json())
      .then(
        (result) => {
          result = result.map(l=>setDuration(l))
          result.sort((a,b) => a.duration - b.duration)
          setLeaders(result)
        },
        (error) => {
          console.log("error: " + error)
        }
      )
      setTimeout(loadingLeaderboard, 30000)
  }
  
  const updateTimers = () => {
      let update = [];
      update = update.concat(leadersRef.current)
    if(update[0]){
      update = update.map(l=>setDuration(l))
      update.sort((a,b) => a.duration - b.duration)
      setLeadersRef.current(update)
    }
  }

  const setDuration = (l) => {
    if(l['endtime']){
      l['duration'] = moment.utc(l.endtime,'MM/DD/YYYY, HH:mm:ss').diff(moment.utc(l.starttime,'MM/DD/YYYY, HH:mm:ss'))
    }else{
      l['duration'] = moment().diff(moment.utc(l.starttime,'MM/DD/YYYY, HH:mm:ss'))
    }
    return l
  }

  useEffect(() => {
    loadingLeaderboard()
    const interval = setInterval(updateTimers, 1000)
    return () => clearInterval(interval);
  }, [])

  const getTimerValue = (duration) => {
    let seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24),
    days = Math.floor((duration / (1000 * 60 * 60 * 24)));
    
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return (days>0?days+":":"") + hours + ":" + minutes + ":" + seconds;
  }
  
  return (
    <div className="container">
      <div className="leadheader">
        <h2>Leaderboard</h2>
      </div>
      <div className="row colheader">
        <div className="position"><h4>#</h4></div>
        <div className="name"><h4>Name</h4></div>
        <div className="time"><h4>Time</h4></div>
      </div>
      {leaders.map((l,i)=>
        <div key={i} className="row users  vcenter">
          <div className="position"><h4>{i+1}</h4></div>
          <div className="name">{l.email}</div>
          <div className="time"><span className={l['endtime']?'ended':'running'}>{getTimerValue(l.duration)}</span></div>
        </div>
      )}
    </div>
  );
}

export default Leader;
